import { ValidatorPosition } from '../../position/validator-position';
export const config = {
    value: 'integer',
    position: [
        ValidatorPosition.filter,
        ValidatorPosition.form,
        ValidatorPosition.formDialog,
        ValidatorPosition.cnArrayTable,
        ValidatorPosition.cnArraySubAreaCard,
    ],
};
